import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { Edit2, Trash2, X, Check, CheckSquare } from 'react-feather'

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from 'common'

export const TableUsers = ({ useFetchInit }) => {
    
    const {
        //------------- Generales
        //------------- globalStates
        // globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    
    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    
    // ------------------------------------------------ FetchData
    const { fetchAllUsers } = FetchData
    const { dataUsers, loadingFetchAllUsers } = fetchAllUsers

    // ------------------------------------------------ Actions
    const { 
        handleClickFetchSpecificUser,
        handleClickEnableUser,
        handleClickDisableUser,
        handleClickDeleteUser,
        handleClickPermissionsModal
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: 'usuario', headerName: 'USUARIO', minWidth: 150, filter: true },
        { field: 'nombre', headerName: 'NOMBRE', minWidth: 300, filter: true },
        { field: 'email', headerName: 'CORREO', minWidth: 300, filter: true },
        {
            headerName: 'Opciones',
            minWidth: 350,
            cellRenderer: (params) => {
                const { idusuario, estado } = params.data

                return (
                    <CustomDropDown color={(estado===1)?'inherit':'error'}>
                        {(estado === 1) && (
                            <div>
                                <MenuItem
                                    onClick={() => handleClickPermissionsModal(
                                        '',
                                        'ASIGNAR PERMISOS',
                                        'FormPermissionAssignment',
                                        { data: params.data }
                                    )}
                                >
                                    <ListItemIcon> <CheckSquare color="black"/> </ListItemIcon>
                                    <ListItemText primary="Permisos" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickFetchSpecificUser(idusuario)}
                                >
                                    <ListItemIcon> <Edit2 color="black"/> </ListItemIcon>
                                    <ListItemText primary="Informacion" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickDeleteUser(idusuario)}
                                >
                                    <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                                    <ListItemText primary="Eliminar" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickDisableUser(idusuario)}
                                >
                                    <ListItemIcon> <X color="black"/> </ListItemIcon>
                                    <ListItemText primary="Desactivar" />
                                </MenuItem>
                            </div>
                        )}
                        {(estado === 0) && (
                            <MenuItem
                                onClick={() => handleClickEnableUser(idusuario)}
                            >
                                <ListItemIcon> <Check color="black"/> </ListItemIcon>
                                <ListItemText primary="Activar" />
                            </MenuItem>
                        )}
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {(loadingFetchAllUsers)&&(<LinearLoading/>)}
            <CustomTableData 
                // datos (listados, individuales)
                rowConfig={dataUsers}
                columnConfig={columnConfig}
                // handleClicks
                // Funciones
            />
        </div>
    )
}
